import { useSelector } from "react-redux";

// Components
import Attempt from "components/atoms/Attempt";

// Selectors
import * as wheelSelector from "redux/landing/wheels/selectors";

const AttemptContainer = () => {
  const { attempts, type } = useSelector(wheelSelector.all);
  return <Attempt attempts={attempts} type={type} />;
};

export default AttemptContainer;
